import {ValueObject} from '@s-ui/domain'

import {SeoHeadValueObject} from './SeoHeadValueObject.js'

export class SeoHelmetValueObject extends ValueObject {
  #h1
  #head

  constructor({h1, head} = {}) {
    super({h1, head})
    this.#h1 = h1
    this.#head = head
  }

  static create({h1, title, description, canonical, scripts} = {}) {
    return new SeoHelmetValueObject({
      h1,
      head: SeoHeadValueObject.create({
        title,
        description,
        canonical,
        scripts
      })
    })
  }

  get h1() {
    return this.#h1
  }

  get head() {
    return this.#head.value
  }

  get value() {
    return {
      h1: this.#h1,
      head: this.#head.value
    }
  }
}
